import { render, staticRenderFns } from "./AdminTeacherSatisfaction.vue?vue&type=template&id=61dc882a&scoped=true&"
import script from "./AdminTeacherSatisfaction.vue?vue&type=script&lang=js&"
export * from "./AdminTeacherSatisfaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dc882a",
  null
  
)

export default component.exports